<h1 class="mat-align-center text-primary text-center">{{ titlePage }}</h1>

<div class="mat-elevation-z8">
    <mat-divider></mat-divider>

    <mat-card>
        <mat-card-content>


            <mat-form-field appearance="fill">
                <mat-label>Data Inicio</mat-label>
                <input matInput [matDatepicker]="begin" [(ngModel)]="beginDate" />
                <mat-datepicker-toggle matSuffix [for]="begin"></mat-datepicker-toggle>
                <mat-datepicker #begin></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Data Fim</mat-label>
                <input matInput [matDatepicker]="end" [(ngModel)]="endDate" />
                <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
                <mat-datepicker #end></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Status do PIX</mat-label>
                <mat-select (selectionChange)="onStatusPixChanged($event)" [(ngModel)]="pixStatusSelected">
                    <mat-option [value]="PixStatusEnum.None_All">Todos</mat-option>
                    <mat-option [value]="PixStatusEnum.Success">Recebido</mat-option>
                    <mat-option [value]="PixStatusEnum.Error">Erros</mat-option>
                </mat-select>
            </mat-form-field>

            <label class="mx-10">
                <mat-checkbox [(ngModel)]="isNegotiation" id="ckNegotiation">Negociação</mat-checkbox>
            </label>

            <button id="btnSearch" mat-button mat-raised-button color="primary" (click)="onFilter()"
                [disabled]="_loaderService.isLoading | async">
                <mat-icon>search</mat-icon> Pesquisar
            </button>

        </mat-card-content>
    </mat-card>

    <hr />

    <div class="row">
        <div class="col-sm-2"></div>
        <div class="col-sm-6">
            <input class="form-control" [(ngModel)]="searchText" (input)="applyFilter()" placeholder="Buscar..." />
        </div>
    </div>

    <mat-card>
        <table class="table table-bordered table-hover p-5">
            <thead class="thead-success">
                <tr>
                    <th [width]="150" class="text-muted">Recebimento</th>
                    <th [width]="100" class="text-muted">Vencimento</th>
                    <th [width]="100" class="text-muted">Nº Fatura</th>
                    <th [width]="100" class="text-muted">Status</th>
                    <th [width]="150" class="text-muted">Observação</th>
                    <th class="text-muted">Json</th>
                    <th class="text-muted"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of filteredData; index as i">
                    <td>{{ data.receivingDate | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
                    <td>{{ data.billetDueDateStr }}</td>
                    <td>{{ data.billetNumber }}</td>
                    <td>
                        <span *ngIf="data.pixStatus == PixStatusEnum.Error">
                            <mat-icon color="warn">close</mat-icon> Erro
                        </span>
                        <span *ngIf="data.pixStatus == PixStatusEnum.Success">
                            <mat-icon style="color: green">done</mat-icon> Recebido
                        </span>
                        <span *ngIf="data.pixStatus == PixStatusEnum.None_All">
                            <mat-icon class="spin" color="accent">sync</mat-icon> Pendente
                        </span>
                    </td>
                    <td>{{ data.errorMessage }}</td>
                    <td>{{ data.json }}</td>
                    <td>
                        <button [disabled]="_loaderService.isLoading | async" mat-icon-button [matMenuTriggerFor]="menu"
                            aria-label="Example icon-button with a menu">
                            <mat-icon>menu</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="gotoAfsBilletId(data.billetId || data.billetIdList[0])"
                                [disabled]="_loaderService.isLoading | async" title="Ir para">
                                <mat-icon>search</mat-icon>
                                <span>Contrato</span>
                            </button>

                            <!-- <button mat-menu-item *ngIf="
                                    permissionResendPix &&
                                    (data.pixStatus == PixStatusEnum.None_All || data.pixStatus == PixStatusEnum.Error)
                                " (click)="sendAgain(data)" [disabled]="_loaderService.isLoading | async">
                                <mat-icon>sync</mat-icon>
                                <span>Reenviar</span>
                            </button> -->

                            <!-- <button mat-menu-item *ngIf="
                                    permissionResendPix &&
                                    (data.pixStatus == PixStatusEnum.None_All || data.pixStatus == PixStatusEnum.Error)
                                " (click)="selectOtherBillets(data)" [disabled]="_loaderService.isLoading | async">
                                <mat-icon>swap_vert</mat-icon>
                                <span>Selecionar Outra Parcela</span>
                            </button> -->
                            
                            <button mat-menu-item (click)="updatePixStatus(data)"
                                [disabled]="_loaderService.isLoading | async">
                                <mat-icon>updatet</mat-icon>
                                <span>Alterar Status</span>
                            </button>
                        </mat-menu>
                    </td>
                </tr>
            </tbody>
        </table>
    </mat-card>
</div>